export default __webpack_public_path__ + "static/media/InfoGrey.77ed3204.svg";